import { brandsPageRegex, categoryBrandPageRegex, discountCodesSlugs } from '$lib';

import type { PageLoad } from './$types';

import { brandsLoad } from './page.brands';
import { categoryLoad } from './page.category';
import { cmsLoad } from './page.cms';
import { discountCodesLoad } from './page.discountCodes';
import { productLoad } from './page.product';

export const load: PageLoad = async (event) => {
	const { params, parent } = event;
	const { rootCategories, cmsPages, store } = await parent();

	if (params.slug === discountCodesSlugs[store.language]) {
		return discountCodesLoad(event);
	}

	if (brandsPageRegex[store.language]?.test(params.slug)) {
		return brandsLoad(event);
	}

	if (categoryBrandPageRegex[store.language]?.test(params.slug)) {
		return categoryLoad(event, true);
	}

	if (rootCategories.includes(params.slug) || params.slug.includes('/')) {
		return categoryLoad(event);
	}

	if (cmsPages && Object.values(cmsPages).find((p: { slug: string }) => p.slug === params.slug)) {
		return cmsLoad(event);
	}

	return productLoad(event);
};
